// extracted by mini-css-extract-plugin
module.exports = {"section":"_3a8gXsEpUaQQsYdBaU78AW _1g3KR6kqUpBj8X0QeYWP8D","sectionHeader":"_34yIgKThMcO2atZAZvqZZT","sectionTitle":"_2bV2Jmx53Z6kcoDF3AO1su"};